import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";
import { api } from "@/lib/api";
import { articleImage } from "@/lib/images";
import { ArrowRight, Clock3 } from "lucide-react";

export default function GuidePreview() {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    api.get("/articles").then((r) => setArticles(r.data.slice(0, 3))).catch(() => {});
  }, []);

  return (
    <section data-testid="guide-preview-section" className="container-site py-20 lg:py-28">
      <Reveal className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
        <div className="max-w-xl">
          <span className="eyebrow">Guide e articoli</span>
          <h2 className="mt-4 text-3xl sm:text-4xl font-extrabold tracking-tight text-brand-ink">
            Conosci i tuoi diritti, in parole semplici.
          </h2>
        </div>
        <Link to="/guide" className="btn-outline shrink-0" data-testid="guide-preview-all-link">
          Tutte le guide
          <ArrowRight className="w-5 h-5" />
        </Link>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
        {articles.map((a, i) => (
          <Reveal key={a.slug} delay={i * 0.1}>
            <Link
              to={`/guide/${a.slug}`}
              data-testid={`guide-preview-card-${a.slug}`}
              className="group block h-full rounded-3xl border border-slate-100 bg-white p-7 shadow-sm hover:shadow-xl hover:shadow-brand-blue/8 hover:-translate-y-1.5 transition-[box-shadow,transform] duration-300"
            >
              <div className="rounded-2xl overflow-hidden mb-5">
                <img src={articleImage(a.slug).url} alt={articleImage(a.slug).alt} loading="lazy" className="w-full h-40 object-cover transition-transform duration-700 group-hover:scale-105" data-testid={`guide-preview-img-${a.slug}`} />
              </div>
              <span className="inline-block rounded-full bg-brand-mist text-brand-blue text-xs font-bold uppercase tracking-wider px-3 py-1.5">
                {a.category}
              </span>
              <h3 className="mt-4 text-xl font-bold text-brand-ink leading-snug group-hover:text-brand-blue transition-colors">
                {a.title}
              </h3>
              <p className="mt-3 text-slate-600 leading-relaxed">{a.excerpt}</p>
              <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-slate-400">
                <Clock3 className="w-4 h-4" /> {a.reading_min} min di lettura
              </span>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
